module.exports = __webpack_public_path__ + "static/media/lu.57b9eece.svg";